module.exports = __webpack_public_path__ + "media/img/home/clients-map/talendo-0f31f95f77f953a74a3397b99ba9984f.svg";